import { render, staticRenderFns } from "./RiskSingleTaskModal.vue?vue&type=template&id=5ab7d979&"
import script from "./RiskSingleTaskModal.vue?vue&type=script&lang=js&"
export * from "./RiskSingleTaskModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports